import { render, staticRenderFns } from "./IolDataTablePower.vue?vue&type=template&id=0ebed05b"
import script from "./IolDataTablePower.vue?vue&type=script&lang=js"
export * from "./IolDataTablePower.vue?vue&type=script&lang=js"
import style0 from "./IolDataTablePower.vue?vue&type=style&index=0&id=0ebed05b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports